import type { MaybeRef } from 'vue';

export const stackletKeys = {
  all: ['stacklets'] as const,
  dataForCreate: () => [...stackletKeys.all, 'data-for-create'] as const,
  stacklets: (
    params: MaybeRef<{
      page: number;
      query?: string;
      status?: 'active' | 'inactive';
      hasBackups?: boolean;
    }>,
  ) => [...stackletKeys.all, 'stacklets', params] as const,
  stacklet: (id: MaybeRef<number>) => [...stackletKeys.all, 'stacklet', id] as const,
  snapshots: (id: MaybeRef<number>) => [...stackletKeys.all, 'snapshots', id] as const,
  volume: (stackletId: MaybeRef<number>, volumeUuid: MaybeRef<string>) =>
    [...stackletKeys.all, 'volume', stackletId, volumeUuid] as const,
  regions: (id: MaybeRef<number>) => [...stackletKeys.all, 'regions', id] as const,
  backups: (id: MaybeRef<number>) => [...stackletKeys.all, 'backups', id] as const,
  firewalls: (id: MaybeRef<number>) => [...stackletKeys.all, 'firewalls', id] as const,
  firewall: (stackletId: MaybeRef<number>, firewallUuid: MaybeRef<string>) =>
    [...stackletKeys.all, 'firewall', stackletId, firewallUuid] as const,
  sizes: (id: MaybeRef<number>) => [...stackletKeys.all, 'sizes', id] as const,
  stackletTask: (id: MaybeRef<number>) => [...stackletKeys.all, 'stacklet-task', id] as const,
  snapshotTask: (id: MaybeRef<number>) => [...stackletKeys.all, 'snapshot-task', id] as const,
  history: (id: MaybeRef<number>, params: MaybeRef<{ page?: number; query?: string }>) =>
    [...stackletKeys.all, 'history', id, params] as const,
};
